var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.843 98.3641L201.163 236.744C231.331 266.854 280.645 266.88 310.838 236.744L449.158 98.3641C450.551 96.9711 450.348 94.6771 448.732 93.5501C434.624 83.7111 417.459 77.8781 398.969 77.8781H113.033C94.542 77.8781 77.377 83.7121 63.269 93.5501C61.653 94.6771 61.45 96.9711 62.843 98.3641ZM25.879 165.031C25.879 150.491 29.484 136.753 35.834 124.678C36.827 122.789 39.344 122.407 40.853 123.916L177.422 260.485C220.669 303.795 291.307 303.82 334.58 260.485L471.149 123.916C472.658 122.407 475.175 122.789 476.168 124.678C482.517 136.753 486.123 150.492 486.123 165.031V346.968C486.123 395.061 447.002 434.122 398.969 434.122H113.033C65.001 434.122 25.879 395.061 25.879 346.968V165.031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4763aefd3ceccd40d3c6a1e31e78c3c6.svg";
export { ForwardRef as ReactComponent };